import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const Root = () => {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorkerRegistration.unregister();
